import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-replacement',
  templateUrl: './replacement.component.html',
  styleUrls: ['./replacement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReplacementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
